import React from 'react';
import PropTypes from 'prop-types';

import Analytics from '@module/analytics';
import I18n from '@module/i18n';
import Router from '@module/router';

import PreviewHelper from '@app/helper/preview';

const GridButton = ({ isPanelOpen, ready, transfer, currentSize }) => {
  const classNames = ['downloader__grid-button'];
  const title = I18n.t('transfer.download.files_nosize.other', {
    count: transfer.items.length,
  });

  let action = (
    <span className="downloader__grid-button-preview">
      {I18n.t('page.advertise.gallery.preview')}
    </span>
  );

  function goToGrid() {
    Router.navigateTo(
      PreviewHelper.getGridUrl({
        transferId: transfer.id,
        recipientId: transfer.recipient_id,
        secret: transfer.secret,
      })
    );
    Analytics.trackSnowplowEvent({
      category: 'preview',
      action: 'click_launch_grid',
    });
  }

  function closePreview() {
    Router.navigateTo(
      PreviewHelper.getTransferDownloadUrl({
        transferId: transfer.id,
        recipientId: transfer.recipient_id,
        secret: transfer.secret,
      })
    );
  }

  let subTitle = I18n.size(currentSize, { precision: 0 });
  let onClick = isPanelOpen ? closePreview : goToGrid;

  if (!ready) {
    action = null;
    onClick = null;
    classNames.push('downloader__grid-button_disabled');
    subTitle = I18n.t('transfer.pending.title');
  }

  if (isPanelOpen) {
    classNames.push('downloader__grid-button_open');
  }

  return (
    <div onClick={onClick} className={classNames.join(' ')}>
      <div className="downloader__grid-button-contents">
        <h3>{title}</h3>
        <div>{subTitle}</div>
      </div>
      <div className="downloader__grid-button-action">{action}</div>
    </div>
  );
};

GridButton.propTypes = {
  isPanelOpen: PropTypes.bool,
  transfer: PropTypes.object.isRequired,
  ready: PropTypes.bool,
  currentSize: PropTypes.number.isRequired,
};

export default GridButton;
